import { useEffect, useState } from 'react';
import { apiGetCaptchaeImg, apiH5RebateApply, apiSendRefundFeeSmsCode } from '../api';
import { showToast } from '../utils/utils';
import MessageDialog from '../components/messageDialog';
interface prompt {
  captchaId?: string,
  captchaImg?: string,
  captchaSwitch?: boolean
}
export default function RefundFeePage() {
  const [activatePhone, setactivatePhone] = useState('');
  const [cardNum, setcardNum] = useState('');
  const [smsCode, setsmsCode] = useState('');
  const [messageDialogShow, setmessageDialogShow] = useState('');
  // 图形验证码弹窗
  const [captchaDialogShow, setcaptchaDialogShow] = useState(false);
  const [captchaCode, setcaptchaCode] = useState('');
  const [captchaChecking, setcaptchaChecking] = useState(false);
  // 短信验证码倒计时
  const [countdown, setCountdown] = useState(0);

  const [promptCode, setpromptCode] = useState<prompt>({});

  useEffect(() => {
    if (countdown <= 0) return;
    const timer = setTimeout(() => setCountdown((count) => count - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown]);

  async function getCodeImg() {
    const res = await apiGetCaptchaeImg()
    if (res?.data?.code === 200) {
      setpromptCode(res?.data?.data || {})
    }
  }
  // 点击获取验证码，先弹出图形验证码
  function handleGetSmsCode() {
    if (!/^1[3-9]\d{9}$/.test(activatePhone)) {
      return showToast('请输入正确的激活号码');
    }
    if (!cardNum) {
      return showToast('请输入您的身份证号');
    }
    if (countdown > 0) {
      return showToast('验证码已发送，请稍后再试');
    }
    setcaptchaCode('');
    setcaptchaDialogShow(true);
    getCodeImg();
  }
  // 图形验证码通过后发送短信验证码
  async function handleSendSmsCode() {
    if (!promptCode.captchaId) {
      return showToast('图形验证码加载中，请稍后重试');
    }
    if (!captchaCode) {
      return showToast('请输入图形验证码');
    }
    setcaptchaChecking(true);
    try {
      const res = await apiSendRefundFeeSmsCode(activatePhone, cardNum, promptCode.captchaId || '', captchaCode);
      if (res?.data?.code === 200) {
        setcaptchaDialogShow(false);
        setcaptchaCode('');
        setCountdown(60);
        showToast('验证码已发送');
      } else {
        setmessageDialogShow(res?.data?.msg ?? '验证码发送失败');
        setcaptchaCode('');
        getCodeImg();
      }
    } catch (e: any) {
      setmessageDialogShow(e?.message ?? '验证码发送失败');
      setcaptchaCode('');
      getCodeImg();
    } finally {
      setcaptchaChecking(false);
    }
  }
  async function handleSubmit() {
    if (!/^1[3-9]\d{9}$/.test(activatePhone)) {
      return showToast('请输入正确的激活号码');
    }
    if (!cardNum) {
      return showToast('请输入您的身份证号');
    }
    if (!smsCode) {
      return showToast('请输入短信验证码');
    }
    const res = await apiH5RebateApply({ activatePhone, cardNum, smsCode })
    if (res?.data?.code === 200) {
      showToast(res?.data?.msg ?? '提交成功')
      setactivatePhone('')
      setcardNum('')
      setsmsCode('')
      setCountdown(0)
    } else {
      setmessageDialogShow(res?.data?.msg ?? '提交失败')
    }
  }
  return (
    <div className='bw-100 d-flex-c jc-center ai-center' style={{ height: '100vh' }}>

      <img src="/pic/refundFeeHeader.jpg" alt="" className='bw-100 h-220' />
      <div className='bw-100 flex-1' style={{
        background: 'url(/pic/refundFeeCenter.jpg) no-repeat center center',
        backgroundSize: '100% 100%', // 按宽度100%缩放，高度自动
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      }}>
        <div className='d-flex-c ai-center jc-between bh-100 bw-100'>
          <div className='d-flex-c ai-center jc-center pl-30 pr-30'>
            <div className="d-flex-r ai-center jc-center font-size-16 pt-15 pb-15 pl-10 pr-10 bg-555 mt-20">
              <span>激活号码</span>
              <div className="flex-1 d-flex-c ai-end">
                <input
                  className="input text-right font-size-16 border-none bg-555"
                  type="text"
                  maxLength={11}
                  placeholder="请输入您的手机号码"
                  value={activatePhone}
                  onChange={(v) => setactivatePhone(v?.target?.value || '')}
                />
              </div>
            </div>
            <div className="d-flex-r ai-center jc-center font-size-16 pt-15 pb-15 pl-10 pr-10 bg-555 mt-15">
              <span>证件号码</span>
              <div className="flex-1 d-flex-c ai-end">
                <input
                  className="input  text-right font-size-16 border-none bg-555"
                  type="text"
                  maxLength={18}
                  placeholder="请输入您的身份证号"
                  value={cardNum}
                  onChange={(v) => setcardNum(v?.target?.value || '')}
                />
              </div>
            </div>
            <div className="d-flex-r ai-center jc-center font-size-16 pt-15 pb-15 pl-10 pr-10 bg-555 mt-15">
              <span>验证码</span>
              <div className="flex-1 d-flex-c ai-end">
                <input
                  className="input text-right font-size-16 border-none bg-555"
                  type="text"
                  maxLength={6}
                  placeholder="请输入短信验证码"
                  value={smsCode}
                  onChange={(v) => setsmsCode(v?.target?.value || '')}
                />
              </div>
              <div
                className={`pl-10 font-size-16 ${countdown > 0 ? 'text-color-9' : 'text-color-red'}`}
                onClick={handleGetSmsCode}
              >
                {countdown > 0 ? `${countdown}s后重发` : '获取验证码'}
              </div>
            </div>
          </div>

          <div className="btn w-120 bg-red mb-50 p-10 border-radius-8 text-center text-color-white" style={{ background: '#e13a3e' }} onClick={handleSubmit}>
            立即领取
          </div>

        </div>

      </div>
      {/* <img src="/pic/refundFeeCenter.jpg" alt="" /> */}
      <img src="/pic/refundFeebottom.jpg" alt="" className='bw-100' />
      {!!messageDialogShow && (
        <MessageDialog title="系统提示" message={messageDialogShow} onClose={() => setmessageDialogShow('')} />
      )}
      {captchaDialogShow && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={() => setcaptchaDialogShow(false)}
        >
          <div
            className="bg-white border-radius-8"
            style={{ width: '80%', maxWidth: 320, padding: 20 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="font-size-16 text-center" style={{ fontWeight: 'bold' }}>图形验证码</div>
            <div className="d-flex-r ai-center mt-20" style={{ border: '1px solid #ddd', borderRadius: 4, padding: '8px 10px' }}>
              <input
                className="input flex-1 font-size-16 border-none"
                type="text"
                maxLength={4}
                placeholder="请输入图形验证码"
                value={captchaCode}
                onChange={(v) => setcaptchaCode(v?.target?.value || '')}
              />
              <img
                src={`data:image/png;base64,${promptCode?.captchaImg}`}
                alt=""
                style={{ width: 100, height: 38 }}
                title="点击刷新验证码"
                onClick={getCodeImg}
              />
            </div>
            <div className="d-flex-r mt-20">
              <div className="flex-1 text-center p-10 border-radius-8 bg-ccc" onClick={() => setcaptchaDialogShow(false)}>取消</div>
              <div
                className="flex-1 text-center p-10 border-radius-8 text-color-white ml-15"
                style={{ background: '#e13a3e' }}
                onClick={captchaChecking ? undefined : handleSendSmsCode}
              >
                {captchaChecking ? '发送中...' : '确定'}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
